import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeState {
  isDark: boolean;
  toggleTheme: () => void;
  setDark: (isDark: boolean) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      isDark: false,
      toggleTheme: () =>
        set((state) => {
          const next = !state.isDark;
          document.documentElement.classList.toggle('dark', next);
          return { isDark: next };
        }),
      setDark: (isDark: boolean) =>
        set(() => {
          document.documentElement.classList.toggle('dark', isDark);
          return { isDark };
        }),
    }),
    {
      name: 'theme',
      version: 2,
      onRehydrateStorage: () => {
        return (state) => {
          document.documentElement.classList.toggle('dark', state?.isDark ?? false);
        };
      },
    }
  )
);
